import { THEME_MODE_MUTATION_OBSERVATION_SCOPE } from "../constants.js";
import { useSyncExternalStore } from "react";
import { useTheme } from "next-themes";
// src/hooks/theme.ts
const subscribeToDocumentThemeMode = (onModeChange) => {
	const observer = new MutationObserver(onModeChange);
	observer.observe(document.documentElement, THEME_MODE_MUTATION_OBSERVATION_SCOPE);
	return () => observer.disconnect();
};
const getDocumentThemeMode = () => document.documentElement.classList.contains("dark") ? "dark" : "light";
const getServerThemeMode = () => "light";
/**
* Directly tracks the theme mode contained in the classlist of `<html>`.
*/
const useDocumentThemeMode = () => useSyncExternalStore(subscribeToDocumentThemeMode, getDocumentThemeMode, getServerThemeMode);
export { useDocumentThemeMode, useTheme };

//# sourceMappingURL=theme.js.map